<template>
  <header
    id="header"
    class="bg-white border-b border-gray-200 sticky top-0 z-50"
  >
    <div class="max-w-7xl mx-auto px-5">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center space-x-3">
          <div
            @click="router.push('/')"
            class="w-10 h-10 bg-primary rounded-lg flex items-center justify-center cursor-pointer"
          >
            <i class="fas fa-leaf text-white text-lg"></i>
          </div>
          <div @click="router.push('/')" class="cursor-pointer">
            <h1 class="text-xl font-semibold text-accent">{{ $t('header.title') }}</h1>
            <p class="text-xs text-gray-500">{{ $t('header.memberSubtitle') }}</p>
          </div>
        </div>
        <div class="flex items-center space-x-4">
          <div class="relative">
            <select
              :value="languageStore.currentLanguage"
              @change="handleLanguageChange"
              class="bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option
                v-for="language in languageStore.availableLanguages"
                :key="language.code"
                :value="language.code"
              >
                {{ language.flag }} {{ language.name }}
              </option>
            </select>
          </div>
          <div class="flex items-center space-x-3">
            <img
              src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
              alt="Developer Avatar"
              class="w-8 h-8 rounded-full"
            />
            <div class="text-sm">
              <div class="font-medium text-accent">Green Energy Corp</div>
              <div class="text-gray-500">DIN: DEV-2024-001</div>
            </div>
          </div>
          <button class="text-gray-600 hover:text-primary">
            <i class="fas fa-cog text-lg"></i>
          </button>
          <button
            @click="router.push('/help')"
            class="text-gray-600 hover:text-primary"
          >
            <i class="fas fa-question-circle text-lg"></i>
          </button>
          
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useLanguageStore } from "@/stores/language";
import type { SupportedLanguage } from "@/stores/language";

const router = useRouter();
const authStore = useAuthStore();
const languageStore = useLanguageStore();
const showDropdown = ref(false);
const dropdownRef = ref<HTMLElement>();

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const handleLogout = async () => {
  showDropdown.value = false;
  await authStore.logout();
};

const handleLanguageChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  languageStore.setLanguage(target.value as SupportedLanguage);
};

const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    showDropdown.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>
